var _metadata, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPirateLeftArmBtm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -0.5 100 150",
    shapeRendering: "crispEdges",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "Made with Pixels to Svg https://codepen.io/shshaw/pen/XbxvNj")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#191718",
    d: "M70 90h10M70 91h10M70 92h10M77 93h3M77 94h3M77 95h3M77 96h3M73 97h4M73 98h4M73 99h4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#26180a",
    d: "M60 93h3M60 94h3M60 95h3M60 96h3M60 97h3M60 98h3M60 99h3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#3a240f",
    d: "M63 93h4M63 94h4M63 95h4M63 96h4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#0f0e0e",
    d: "M67 93h3M67 94h3M67 95h3M67 96h3M63 97h4M77 97h3M63 98h4M77 98h3M63 99h4M77 99h3M63 100h14M63 101h14M63 102h14"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#3f3c3d",
    d: "M70 93h3M70 94h3M70 95h3M70 96h3M67 97h3M67 98h3M67 99h3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#b3761d",
    d: "M73 93h4M73 94h4M73 95h4M73 96h4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "#504b4c",
    d: "M70 97h3M70 98h3M70 99h3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    stroke: "#320e0b",
    d: "M60 100h3M60 101h3M60 102h3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPirateLeftArmBtm);
export default __webpack_public_path__ + "static/media/pirate-LeftArmBtm.1e79e6b58861ce8eda03e2194bce0184.svg";
export { ForwardRef as ReactComponent };